/* Vendors */
import 'normalize.css'
import '@fortawesome/fontawesome-free/css/all.min.css'

require('./variables.css')
require('./media.css')
require('./helpers.css')
require('./grid.css')
require('./icons.css')
require('./styles.css')
require('./fonts.css')
require('./forms.css')
require('./lazy-load.css')
require('./applications.css')
require('./custom-pagination.css')
require('./total-price.css')
require('./utils.css')
/* All components */

function requireAll (requireContext) {
  return requireContext.keys().map(requireContext)
}
requireAll(require.context('./components', false, /.css$/))
